let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eWNyL")).then(() => parcelRequire('cfn6I'));